// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"42bb86ce","429":"7749d97b"}[chunkId] + ".chunk.css";
};